import {Outlet} from "react-router";

export default function DungeonWorkspace() {
    return <div className="flex min-h-0 min-w-0 flex-1 flex-col bg-background p-3"><Outlet/></div>;
}
